export const firebaseConfig = {
  apiKey: "AIzaSyAA-KB4dTPhi4LaqblhHl4uYBCaFauJFPg",
  authDomain: "fantasyloser-f6991.firebaseapp.com",
  projectId: "fantasyloser-f6991",
  storageBucket: "fantasyloser-f6991.appspot.com",
  messagingSenderId: "240012027880",
  appId: "1:240012027880:web:be8a7e0a5d579c5340265d",
  measurementId: "G-4GGYREH9RV",
  automaticDataCollectionEnabled: true
};